<template>
  <div>
    <div role="tablist">
      <b-card v-for="item in kewajibanRows" :key="item.id" no-body class="mb-3">
        <b-card-header header-tag="header" class="p-0" role="tab">
          <b-button v-b-toggle="`kewajiban-pusat-${item.id}`" block variant="light" class="text-left text-wrap">
            <div class="d-flex align-items-center justify-content-between">
              <span class="mr-3">{{ item.title }}</span>
              <b-badge :variant="getPenilaianVariant(item.hasil_penilaian)">
                {{ item.hasil_penilaian || 'Belum Dinilai' }}
              </b-badge>
            </div>
          </b-button>
        </b-card-header>

        <b-collapse
          :id="`kewajiban-pusat-${item.id}`"
          accordion="kewajiban-pusat"
          :visible="item.id === 1"
          role="tabpanel"
        >
          <b-card-body>
            <b-row>
              <b-col cols="12" md="7" class="mb-3 mb-md-0">
                <b-form-group :label-for="`deskripsi-kewajiban-${item.id}`">
                  <label :for="`deskripsi-kewajiban-${item.id}`">Deskripsi</label>
                  <b-form-textarea
                    :id="`deskripsi-kewajiban-${item.id}`"
                    :value="item.deskripsi"
                    rows="4"
                    disabled
                    placeholder="Deskripsi belum tersedia."
                    style="background-color: #dddddd !important; opacity: 0.7"
                  />
                </b-form-group>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  :disabled="!hasBuktiDukung(item.id_file)"
                  @click="unduhBuktiDukung(item.id_file)"
                >
                  <i class="fa fa-download"></i> Unduh Bukti Dukung
                </b-button>
                <small v-if="!hasBuktiDukung(item.id_file)" class="d-block text-muted mt-1">
                  Bukti dukung belum tersedia.
                </small>
              </b-col>

              <b-col cols="12" md="5">
                <b-form-group :label-for="`hasil-kewajiban-${item.id}`">
                  <template #label>Hasil Penilaian <span class="text-danger">*</span></template>
                  <b-form-radio-group
                    :id="`hasil-kewajiban-${item.id}`"
                    :name="`hasil-kewajiban-${item.id}`"
                    :checked="item.hasil_penilaian"
                    :options="[
                      { text: 'Sesuai', value: 'Sesuai' },
                      { text: 'Tidak Sesuai', value: 'Tidak Sesuai' },
                    ]"
                    @input="updatePenilaian(item.id, $event)"
                  />
                </b-form-group>
                <b-form-textarea
                  :id="`catatan-kewajiban-${item.id}`"
                  :value="item.catatan_penilaian"
                  rows="4"
                  placeholder="Catatan Penilaian"
                  @input="updateCatatan(item.id, $event)"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div>
        <b-button variant="success" class="mr-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="primary" @click="$emit('selanjutnya')">Selanjutnya</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { kewajibanItems, createEmptyKewajiban } from './kewajibanItems'
import api from '@/services/api'
import Swal from 'sweetalert2'

export default {
  name: 'FormKewajibanPusat',
  props: {
    value: {
      type: Object,
      default: createEmptyKewajiban,
    },
    informasiKewajiban: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isSaving: false,
    }
  },
  computed: {
    idPelaksanaanPenilaian() {
      return this.$route.query.id_pelaksanaan_penilaian || ''
    },
    kewajibanRows() {
      const jawaban = this.value.items || []

      return kewajibanItems.map((kewajiban) => {
        const hasil = jawaban.find((item) => item.id === kewajiban.id) || {}
        const informasi = this.informasiKewajiban.find((item) => item.id === kewajiban.id) || {}

        return {
          ...kewajiban,
          deskripsi: informasi.deskripsi || '',
          id_file: informasi.id_file || 0,
          hasil_penilaian: hasil.hasil_penilaian || '',
          catatan_penilaian: hasil.catatan_penilaian || '',
        }
      })
    },
  },
  methods: {
    getPenilaianVariant(hasilPenilaian) {
      if (hasilPenilaian === 'Sesuai') return 'success'
      if (hasilPenilaian === 'Tidak Sesuai') return 'danger'
      return 'secondary'
    },
    updatePenilaian(id, hasilPenilaian) {
      const items = this.kewajibanRows.map((item) => ({
        id: item.id,
        hasil_penilaian: item.id === id ? hasilPenilaian : item.hasil_penilaian,
        catatan_penilaian: item.catatan_penilaian,
      }))

      this.$emit('input', { items })
    },
    updateCatatan(id, catatanPenilaian) {
      const items = this.kewajibanRows.map((item) => ({
        id: item.id,
        hasil_penilaian: item.hasil_penilaian,
        catatan_penilaian: item.id === id ? catatanPenilaian : item.catatan_penilaian,
      }))

      this.$emit('input', { items })
    },
    buildPenilaianFormData() {
      const formData = new FormData()
      const items = this.value.items || []

      const appendIfFilled = (key, value) => {
        if (value === undefined || value === null || String(value).trim() === '') return
        formData.append(key, value)
      }

      kewajibanItems.forEach((kewajiban) => {
        const item = items.find((entry) => entry.id === kewajiban.id) || {}

        appendIfFilled(`hasil_penilaian_${kewajiban.id}`, item.hasil_penilaian)
        appendIfFilled(`catatan_penilaian_${kewajiban.id}`, item.catatan_penilaian)
      })

      return formData
    },
    async simpanKewajiban() {
      const id = this.idPelaksanaanPenilaian
      if (!id) {
        Swal.fire('Gagal', 'Simpan data identitas terlebih dahulu', 'warning')
        return false
      }

      this.isSaving = true
      try {
        await api.post(`api/pelaksanaan_penilaian/${id}`, this.buildPenilaianFormData())
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan penilaian kewajiban'
        Swal.fire('Gagal', message, 'error')
        return false
      } finally {
        this.isSaving = false
      }
    },
    hasBuktiDukung(idFile) {
      return Number(idFile) > 0
    },
    async unduhBuktiDukung(idFile) {
      if (!this.hasBuktiDukung(idFile)) return

      try {
        const res = await api.get(`api/files/download/${idFile}`, { responseType: 'blob' })
        const file = new Blob([res.data], { type: res.data.type })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL, '_blank')
      } catch (error) {
        Swal.fire('Gagal', 'Gagal mengunduh bukti dukung', 'error')
      }
    },
  },
}
</script>
